var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#3D1CAF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15H13.5C13.9125 15 14.25 14.6625 14.25 14.25V10.5H15.4425C16.11 10.5 16.4475 9.69004 15.975 9.21754L12.5325 5.77504C12.24 5.48254 11.7675 5.48254 11.475 5.77504L8.0325 9.21754C7.56 9.69004 7.89 10.5 8.5575 10.5H9.75V14.25C9.75 14.6625 10.0875 15 10.5 15ZM7.5 16.5H16.5C16.9125 16.5 17.25 16.8375 17.25 17.25C17.25 17.6625 16.9125 18 16.5 18H7.5C7.0875 18 6.75 17.6625 6.75 17.25C6.75 16.8375 7.0875 16.5 7.5 16.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadButton);
export default __webpack_public_path__ + "static/media/UploadButton.e3cbe7bfafd65182fe86a69964128eb8.svg";
export { ForwardRef as ReactComponent };